import { TagManagerArgs } from '@sooro-io/react-gtm-module';
import { getConfigValuesFromEnv } from '../utils';
import { TENANT_NAME } from './tenants';

export const loadTagManagerArgs: Promise<TagManagerArgs | undefined> = getConfigValuesFromEnv().then((configValues) => {
  const gtmId = configValues[TENANT_NAME].gtmId;

  if (!gtmId) return;

  return Promise.resolve({ gtmId } as TagManagerArgs);
});
